export default __webpack_public_path__ + "static/media/Enchanted_Golden_Apple.7a8099bf.gif";